import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal'
import {supabase, supabaseUrl} from "./supabaseClient"
import { v4 as uuidv4 } from 'uuid';

export default function EditArticle({modal_open, closeModal, article}:any){

  const [title, set_title] = useState(article.title)
  const [content, set_content] = useState(article.content)

  const [image_file, set_image_file] = useState<any>(null)
  const [image_url, set_image_url] = useState<string>("")

  useEffect(()=>{
    set_title(article.title)
    set_content(article.content)
    set_image_file(null)
  }, [modal_open])


  const updateArticle = async() => {


    console.log("update article")
    const edite_article:any = {
      title: title,
      content: content,
    }

    //upload image
    if(image_file != null) {
      const file_ext = image_file.name.split('.').pop()
      const file_name = `${uuidv4()}.${file_ext}`
      const file_path = `${file_name}`
      const { error: uploadError } = await supabase.storage.from('title_image').upload(file_path, image_file)

      if(uploadError) {
        alert(uploadError.message)
        return 
      }

      edite_article.title_img = file_path
    }else {
      edite_article.title_img = article.title_img
    }

    console.log(edite_article)

    console.log(article.id)

    const { data, error }:any = await supabase
      .from('article')
      .update(edite_article)
      .eq('id', article.id)
      .select()
    

    console.log("Post")
    console.log(data)
    console.log(error)

    if(error){
      alert("保存に失敗しました")
    }else{
      window.location.reload()
    }

  }

  const handleFile = (e:any) => {
      let file = e.target.files[0];
      const fileType = file['type'];
      const validImageTypes = ['image/jpeg', 'image/png'];
      if (validImageTypes.includes(fileType)) {
          set_image_file(file);
          set_image_url(URL.createObjectURL(file))
      }
  }

  const resetFile = (e:any) => {
    e.target.value =null
  }

  return (
    <div>
      <Modal
        isOpen={modal_open}
        onRequestClose={closeModal}
      >
        <div className="bg-white py-6 sm:py-8 lg:py-12">
          <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
            <div className="mb-10 md:mb-16">
              <h2 className="mb-4 text-center text-2xl font-bold text-gray-800 md:mb-6 lg:text-3xl">記事の編集</h2>

              {

              //<p className="mx-auto max-w-screen-md text-center text-gray-500 md:text-lg">This is a section of some simple filler text, also known as placeholder text. It shares some characteristics of a real written text but is random or otherwise generated.</p>
              }
            </div>

            <div className="mx-auto grid max-w-screen-md gap-4 sm:grid-cols-2">
              <div className="sm:col-span-2">
                <fieldset className="w-full space-y-1 text-gray-800">
                  <label className="mb-2 inline-block text-sm text-gray-800 sm:text-lg">タイトル用画像</label>
                  <div>既存の画像</div>
                  <img className="h-auto w-auto rounded-md" src={`${supabaseUrl}/storage/v1/object/public/title_image/${article.title_img}`} />
                  <div>新規画像</div>
                	<div className="flex">
                    <div className="p-4 border-2 border-dashed rounded-md border-gray-300 bg-gray-100">
                      <label className="flex flex-col w-full h-auto hover:bg-gray-100 hover:border-gray-300">
                        {
                          image_file != null ?
                          <>
                            <img className="h-auto w-auto rounded-md" src={image_url} />
                          </>
                          :
                          <div className="flex flex-col items-center justify-center pt-7">
                              <svg xmlns="http://www.w3.org/2000/svg"
                                  className="w-12 h-12 text-gray-400 group-hover:text-gray-600" viewBox="0 0 20 20"
                                  fill="currentColor">
                                  <path fill-rule="evenodd"
                                      d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                                      clip-rule="evenodd" />
                              </svg>
                              <p className="pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600">
                                  Select a photo</p>
                          </div>
                        }
		                      <input type="file" accept="image/png, image/jpeg" onClick={resetFile} onChange={handleFile} className="opacity-0" />
                        </label>
                        {
                          image_file != null &&
                            <button onClick={()=>set_image_file(null)} className="hover:text-red-500">Clear</button>
                        }
                    </div>
                	</div>
                </fieldset>
              </div>

              <div className="sm:col-span-2">
                <label className="mb-2 inline-block text-sm text-gray-800 sm:text-lg">タイトル</label>
                <input className="w-full rounded border bg-gray-50 px-3 py-2 text-gray-800 outline-none ring-indigo-300 transition duration-100 focus:ring" 
                        value={title} onChange={(e)=>set_title(e.target.value)}
                />
              </div>

              <div className="sm:col-span-2">
               <label className="mb-2 inline-block text-sm text-gray-800 sm:text-lg">コンテンツ</label>
               <textarea className="h-64 w-full rounded border bg-gray-50 px-3 py-2 text-gray-800 outline-none ring-indigo-300 transition duration-100 focus:ring"
                          value={content} onChange={(e)=>set_content(e.target.value)}
               />
              </div>         

              <div>
                <button type="button" onClick={updateArticle} className="px-8 py-3 mx-4 font-semibold rounded-full dark:bg-green-100 dark:text-green-800">編集保存</button>
                <button type="button" onClick={closeModal} className="px-8 py-3 font-semibold rounded-full dark:bg-red-100 dark:text-red-800">閉じる</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}